import React from "react";
import PropTypes from "prop-types";

import withStyles from '@mui/styles/withStyles';

import QualificationComponent from './QualificationComponent';
import { ReclamationQualificationDetailType } from 'constants.js';
import { ReclamationQualificationDetailCodes } from 'constants.js';

import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';


const savByFoussierConcerneLabel = "Le SAV concerne : ";
const savByFoussierConcerneLabels = [
    "la machine selectionnée.",
    "un élément du pack selectionné."
];


const styles = theme => ({
    row: {
        flexBasis: '100%',
        marginBottom: '10px'
    },

    formControl: {
        margin: theme.spacing(1)
    },

    group: {
        margin: theme.spacing(1, 0)
    },
    heightLabel: {
        height: '30px'
    },
});



class SavByFoussierConcerne extends QualificationComponent {


    constructor(props) {
        super(props);

        this.state = {
            ...this.state,

            [ReclamationQualificationDetailCodes.SavByFoussierConcerne]: ''
        };

        this.generableCodes = [
            ReclamationQualificationDetailCodes.SavByFoussierConcerne,
        ];
    }





    componentDidMount() {
        const { name } = this.props;
        const { position, toAdd, toDelete } = this.getQualificationData(this.state);

        this.props.onChange(name, position, toAdd, toDelete, "Mount");

    }

    getQualificationData(newState) {

        // Préparation des codes à supprimer (tous les codes générables)
        let toDelete = [...this.generableCodes];

        if ((newState[ReclamationQualificationDetailCodes.SavByFoussierConcerne] === '')
        ) {
            return {
                name: newState.name,
                position: this.props.position,
                toAdd: null,
                toDelete: toDelete
            };
        }



        let toAdd = [];

        toAdd.push({
            position: 0,            
            code: ReclamationQualificationDetailCodes.SavByFoussierConcerne,
            type: ReclamationQualificationDetailType.ChoixSimple,
            libelle: savByFoussierConcerneLabel,
            valeurString: savByFoussierConcerneLabels[newState[ReclamationQualificationDetailCodes.SavByFoussierConcerne]],
            valeurInteger: parseInt(newState[ReclamationQualificationDetailCodes.SavByFoussierConcerne], 10)
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.SavByFoussierConcerne);



        return {
            name: newState.name,
            position: this.props.position,
            toAdd: toAdd,
            toDelete: toDelete
        }
    }


    render() {
        const { name } = this.props;

        return (




                <FormControl id={name} required>
                    <FormLabel>{savByFoussierConcerneLabel}</FormLabel>
                    <RadioGroup
                        name={ReclamationQualificationDetailCodes.SavByFoussierConcerne}
                        value={this.state[ReclamationQualificationDetailCodes.SavByFoussierConcerne]}
                        onChange={this.handleChange}
                    >
                        {savByFoussierConcerneLabels.map((reponse, index) => (
                            <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={reponse} />
                        ))}
                    </RadioGroup>
                </FormControl>



        );
    }

}


SavByFoussierConcerne.propTypes = {
    name: PropTypes.string.isRequired
};

//SavByFoussierConcerne.defaultProps = {
//};

export default withStyles(styles)(SavByFoussierConcerne);